var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.4A6.4 6.4 0 108 1.6a6.4 6.4 0 000 12.8z",
    fill: "#FE5B4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68 11a.4.4 0 01-.4.4h-.56a.4.4 0 01-.4-.4v-.56c0-.22.18-.4.4-.4h.56c.221 0 .4.18.4.4V11zm0-2.28a.4.4 0 01-.4.4h-.56a.4.4 0 01-.4-.4V4.96c0-.22.18-.4.4-.4h.56c.221 0 .4.18.4.4v3.76z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/icon_warning-red.eddf20d8.svg";
export { SvgIconWarningRed as ReactComponent };